import type { GameDefinition } from './gameDefinitions'

export interface GameItem {
  id: string
  game_id: string
  gamer_handle: string
  position: number
  game: GameDefinition
}

export const useGamesStore = defineStore('games', () => {
  const games = ref<GameItem[]>([])
  const fetchedAt = ref<number | null>(null)
  const isLoading = ref(false)

  const MAX_AGE_MS = 23 * 60 * 60 * 1000 // 23 hours

  function isStale() {
    if (!fetchedAt.value) return true
    return Date.now() - fetchedAt.value > MAX_AGE_MS
  }

  async function fetchGames(characterId: string, force = false) {
    if (!force && !isStale() && games.value.length > 0) {
      return games.value
    }

    isLoading.value = true
    try {
      const data = await $fetch<{ games: GameItem[] }>(`/api/character/${characterId}/game`)
      games.value = data.games
      fetchedAt.value = Date.now()
      return data.games
    } catch (error) {
      console.error('Failed to fetch character games:', error)
      games.value = []
      return []
    } finally {
      isLoading.value = false
    }
  }

  function invalidate() {
    fetchedAt.value = null
  }

  function clear() {
    games.value = []
    fetchedAt.value = null
  }

  return {
    games,
    isLoading,
    fetchedAt,
    fetchGames,
    invalidate,
    clear
  }
})
